import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICourseCategory } from "../../../Pages/CourseCategory/ICourseCategory";

export const AddCourseCategorySlice = createSlice({
  name: "AddCourseCategorySlice",
  initialState: {} as IReduxState<ICourseCategory>,
  reducers: {
    addCourseCategory: (state, action) => {
      state.isLoading = true;
    },
    successaddCourseCategory: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddCourseCategory: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    resetaddCourseCategory: (state) => {
      state.data = {} as ICourseCategory;
      state.isLoading = false;
    },
  },
});

export const { failureaddCourseCategory, addCourseCategory, successaddCourseCategory, resetaddCourseCategory } =
  AddCourseCategorySlice.actions;

export default AddCourseCategorySlice.reducer;
